import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../shared/Card';
import { ANALYSIS_CATEGORIES } from './categories';
import { useAnalysisEntitlement } from '../../hooks/analysis/useAnalysisEntitlement';
import './AnalysisDashboard.css';

/**
 * Hub page at /analysis: one tile per category (mirrors LandingDashboard).
 * Locked tiles (above the subscription tier) are greyed with an upgrade
 * hint; future categories show "coming soon".
 */
const AnalysisDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { entitlement } = useAnalysisEntitlement();
  const enabled = new Set(entitlement.enabled_categories);

  return (
    <div className="analysis-dashboard">
      <p className="analysis-dashboard-subtitle">
        Business analytics for your campground — pick a category to dive in.
      </p>
      <div className="analysis-dashboard-cards">
        {ANALYSIS_CATEGORIES.map(category => {
          const isEnabled = enabled.has(category.id);
          if (category.available && isEnabled) {
            return (
              <Card
                key={category.id}
                title={category.label}
                description={category.description}
                icon={category.icon}
                onClick={() => navigate(`/analysis/${category.path}`)}
              />
            );
          }
          return (
            <div key={category.id} className="analysis-dashboard-locked">
              <Card
                title={`${category.label} 🔒`}
                description={
                  category.available
                    ? 'Upgrade your Analysis subscription to unlock this category.'
                    : 'Coming soon.'
                }
                icon={category.icon}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnalysisDashboard;
